import { createContext, useContext } from 'react';
import type { OpenIntent } from './resolveOpenIntent';

/**
 * `seriesKeys` is the drilldown's selection, or `'all'` for every dataset.
 *
 * `intent` narrows the open to a case or a selection. Either way the workflow
 * and the objects to select are resolved from the course stage and the
 * primaries of what is opened.
 */
export type OpenInViewer = (
    patientId: string,
    seriesKeys: readonly string[] | 'all',
    intent?: OpenIntent
) => void;

/**
 * Supplied by `OpenInViewerDownloader`, mounted above the worklist screen so
 * closing the patient panel cannot destroy a retrieval in flight. A context
 * because this direction is a call; the handoff to the viewer runs the other
 * way, through `pendingViewerOpenState`.
 */
export const OpenInViewerContext = createContext<OpenInViewer | null>(null);

/** Opens a worklist patient in the viewer. Requires `OpenInViewerDownloader`. */
export function useOpenInViewer(): OpenInViewer {
    const open = useContext(OpenInViewerContext);
    if (!open) {
        throw new Error(
            'useOpenInViewer requires an enclosing OpenInViewerDownloader'
        );
    }
    return open;
}
